import { useSelector } from "react-redux";
import { FloatPanel } from "../../../../../components/floatPanel";
import { ChannelEditor } from "./reference";
import "./reference.css";
export const Edition = () => {
  const panel = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel,
  );
  return (
    <FloatPanel
      className="channelReferencePanel"
      template={<ChannelEditor key={`${panel.queryId}-${panel.isEmpty}`} />}
    />
  );
};
